module.exports = __webpack_public_path__ + "img/t14.6c91fd72.jpg";